import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-overlay">
        <div className="footer-container">
          
          {/* الصف العلوي - المحتوى الرئيسي */}
          <div className="footer-main-content">
            
            {/* قسم الشعار والوصف */}
            <div className="footer-brand">
<img 
  src="https://i.ibb.co/23jjJwvn/Whats-App-Image-2025-11-20-at-18-20-03-babbe714-removebg-preview.png" 
  alt="Realm of Herbs - Premium Organic Herbs" 
  width="180"
  height="150"
  className="footer-logo-img"
/>
              <p className="footer-description">
                At Realm of Herbs, we deliver premium, farm-fresh herbs, spices, and seeds.
                Our commitment is to provide 100% natural and organic products, bringing 
                the finest flavors and health benefits straight to your doorstep.
              </p>
            </div>

            {/* قسم الروابط */}
            <div className="footer-links-section ">
              <div className="footer-links-group">
                <h3 className="footer-links-title">Quick Links</h3>
                <ul className="footer-links">
                  <li><Link to="/home">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/products">Products</Link></li>
                  <li><Link to="/gallery">Gallery</Link></li>
                </ul>
              </div>

              {/* قسم التواصل */}
              <div className="footer-links-group">
                <h3 className="footer-links-title">Contact Info</h3>
                <div className="contact-info">
                  <div className="contact-item">
                    <i className="fas fa-map-marker-alt "></i>
                    <div>
                      <strong>Address</strong>
                      <p>Egypt, Bani Swif, Smsta</p>
                    </div>
                  </div>
                  
                  <div className="contact-item">
                    <i className="fas fa-phone"></i>
                    <div>
                      <strong>Phone</strong>
                      <p>+201221691637</p>
                      <p>+201227479176</p>
                    </div>
                  </div>
                  
                  <div className="contact-item">
                    <i className="fas fa-envelope"></i>
                    <div>
                      <strong>Email</strong>
                      <p>export@realmofherbs.com</p>
                      <p>ceo@realmofherbs.com</p>
                      <p>sales@realmofherbs.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* قسم وسائل التواصل الاجتماعي */}
            <div className="footer-social-section">
              <h3 className="footer-links-title">Follow Us</h3>
              <div className="social-icons">
                <a 
                  href="https://www.facebook.com/share/1BzQdX7m8Z/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a 
                  href="https://www.linkedin.com/in/sherif-ibrahim-18a61b234" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="LinkedIn"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a 
                  href="https://wa.me/201221691637" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="WhatsApp"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
                <a 
                  href="#" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
          
          {/* الخط الفاصل */}
          <div className="footer-divider"></div>

          {/* الصف السفلي - حقوق النشر */}
          <div className="footer-bottom">
            <div className="copyright">
              <p>&copy; {new Date().getFullYear()} Realm of Herbs. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;